module.exports = __webpack_public_path__ + "img/Frame Circle Desktop.72ab8683.webp";